import React, { useState } from 'react';

import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import UploadButton from 'on_web/components/shared/Common/UploadButton/UploadButton';
import SectionTitle from 'on_web/components/shared/Common/SectionTitle';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import { UploadIcon } from 'on_web/assets/iconsList';
import UserProfileContext from 'on_web/context/userProfileContext';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'react-i18next';

export default function DnaUploadFile(props) {
  const context = React.useContext(UserProfileContext);
  const [selectedFile, setSelectedFile] = useState(undefined);
  const [userPaid] = useState(
    context && context.user_metadata && context.user_metadata.userPaid
      ? context.user_metadata.userPaid
      : false
  );

  const { t } = useTranslation();

  const onClickNext = () => {
    if (props.onClickNext) {
      props.onClickNext();
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const onFileSelect = e => {
    setSelectedFile(e);
    props.onClickNext(e);
  };

  const getDownloadInstructions = code => {
    switch (code) {
      case '1':
        return t(
          'onboarding.dnaSection.dnaUploadFile.downloadInstructions.23andMe'
        );
      case '2':
        return t(
          'onboarding.dnaSection.dnaUploadFile.downloadInstructions.ancestry'
        );
      case '3':
        return t(
          'onboarding.dnaSection.dnaUploadFile.downloadInstructions.familyTreeDna'
        );
      default:
        return;
    }
  };

  return (
    <div>
      <Header />
      {props.forPce && <PceStepProgressIndicator selectedSlideIx={0} />}
      <SectionTitle
        text={
          props.returningVisit
            ? t(
                'onboarding.dnaSection.dnaUploadFile.sectionTitleReturningVisit'
              )
            : t('onboarding.dnaSection.dnaUploadFile.sectionTitle')
        }
      />
      <Box
        pt={{ xs: 2.5, sm: 3, md: 4 }}
        mr={{ xs: 2.5 }}
        justifyContent="center"
        display="flex"
      >
        <UploadIcon height={55} width={55} />
      </Box>
      <Box
        p={{ xs: 2.5, sm: 3, md: 4 }}
        mr={{ xs: 2.5 }}
        justifyContent="center"
        display="flex"
      >
        <UploadButton
          variant="outlined"
          onFileSelected={e => onFileSelect(e)}
          disabled={userPaid !== true}
        >
          {t('onboarding.dnaSection.dnaUploadFile.button')}
        </UploadButton>
      </Box>
      <Box
        p={{ xs: 2.5, sm: 3, md: 4 }}
        mr={{ xs: 2.5 }}
        justifyContent="center"
        display="flex"
      >
        <Typography variant="body1">
          {props.returningVisit
            ? t('onboarding.dnaSection.dnaUploadFile.instructionReturningVisit')
            : t('onboarding.dnaSection.dnaUploadFile.instruction')}
        </Typography>
      </Box>
      {context && context.user_metadata && context.user_metadata.dnaProviders && (
        <Box
          px={{ xs: 2.5, sm: 3, md: 4 }}
          mr={{ xs: 2.5 }}
          display="flex"
          justifyContent="center"
        >
          <Typography style={{ fontSize: '14px' }} align="center">
            <div
              dangerouslySetInnerHTML={{
                __html: getDownloadInstructions(
                  context.user_metadata.dnaProviders
                ),
              }}
            />
          </Typography>
        </Box>
      )}
      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
        nextButtonDisabled={selectedFile == null}
      />
    </div>
  );
}
